module.exports = __webpack_public_path__ + "img/1alB-z-zah.8b188ab8.jpg";